import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FaqHero from './components/FaqHero';
import FaqAccordion from './components/FaqAccordion';
import FaqCta from './components/FaqCta';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

import PageCta from '@/components/feature/PageCta';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'name': '常見問答｜保險建築師 FAQ 保險知識',
  'url': `${siteUrl}/faq`,
  'description': '保險建築師為您整理最常見的保險問題，包含保單選擇、理賠流程、保費計算等實用解答。',
  'mainEntity': [
    {
      '@type': 'Question',
      'name': '為什麼需要保單健檢？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '人生階段不斷變化，保單也應與時俱進。定期保單健檢可以檢視保障是否仍然足夠、保費是否合理、是否有重複投保或缺口，確保每一分保費都用在最需要的地方。',
      },
    },
    {
      '@type': 'Question',
      'name': '醫療保險該如何選擇？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '選擇醫療保險應從個人健康狀況、家族病史、預算及現有保障出發。建議至少包含住院醫療、重大疾病及實支實付三大保障，並依照年齡與生活階段調整。',
      },
    },
    {
      '@type': 'Question',
      'name': '什麼時候開始規劃退休保險最合適？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '越早開始越好。建議在30-35歲就開始退休規劃，讓時間複利發揮最大效益。若已超過40歲，更應立即啟動，用較高保費換取穩定的退休現金流。',
      },
    },
    {
      '@type': 'Question',
      'name': '理賠申請的流程是什麼？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '一般理賠流程為：備妥診斷證明書與收據 → 填寫理賠申請書 → 送交保險公司 → 審核 → 撥款。建議出院前先與保險顧問確認所需文件，避免遺漏。',
      },
    },
    {
      '@type': 'Question',
      'name': '長期照護保險與失能險有什麼不同？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '長期照護保險針對因老化或疾病導致生活無法自理者，提供長期照護金；失能險則針對因意外或疾病導致失能，依失能等級給付。兩者保障範圍不同，建議依家庭需求搭配規劃。',
      },
    },
  ],
};

export default function Faq() {
  useTitle({
    title: '常見問答｜保險建築師 FAQ 保險知識',
    description: '保險建築師為您整理最常見的保險問題，包含保單選擇、理賠流程、保費計算等實用解答。',
    canonicalPath: '/faq',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <FaqHero />
      <FaqAccordion />
      <FaqCta />
      <PageCta />
      <Footer />
    </main>
  );
}